import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { getLatestMessage } from "redux-flash";
import queryString from "query-string";
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector, change } from "redux-form";
import { TextField, Select } from "redux-form-material-ui";
import Button from "material-ui/Button";
import { MenuItem } from "material-ui/Menu";
import { CircularProgress } from "material-ui/Progress";
import { FormControl } from "material-ui/Form";
import { InputLabel } from "material-ui/Input";
import Typography from "material-ui/Typography";

import CenteredForm from "../utils/form/CenteredForm";
import { required } from "../utils/form/formValidation";

import { completeSubscriptionRequest } from "./actions";

import styles from "./CompleteSubscription.scss";

const months = [
  { name: "Janvier", days: 31 },
  { name: "Février", days: 28 },
  { name: "Mars", days: 31 },
  { name: "Avril", days: 30 },
  { name: "Mai", days: 31 },
  { name: "Juin", days: 30 },
  { name: "Juillet", days: 31 },
  { name: "Août", days: 31 },
  { name: "Septembre", days: 30 },
  { name: "Octobre", days: 31 },
  { name: "Novembre", days: 30 },
  { name: "Décembre", days: 31 },
];

const getDayCount = (month, year) => {
  let dayCount = month === -1 ? 31 : months[month].days;
  const isLeap = year === -1 ? true : new Date(year, 1, 29).getMonth() === 1;
  if (month === 1 && isLeap) {
    dayCount += 1;
  }

  return dayCount;
};

class CompleteSubscription extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    completeSubscriptionRequest: PropTypes.func.isRequired,
    "complete-subscription": PropTypes.shape({
      requesting: PropTypes.bool.isRequired,
      successful: PropTypes.bool.isRequired,
    }).isRequired,
    location: PropTypes.objectOf(PropTypes.any).isRequired,
    birthDay: PropTypes.number,
    birthMonth: PropTypes.number,
    birthYear: PropTypes.number,
    changeBirthDay: PropTypes.func.isRequired,
    snackbarMessage: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  static defaultProps = {
    birthDay: -1,
    birthMonth: -1,
    birthYear: -1,
  };

  componentWillReceiveProps(nextProps) {
    const { birthDay, birthMonth, birthYear } = nextProps;

    if (birthMonth === -1) {
      return;
    }

    const dayCount = getDayCount(birthMonth, birthYear);

    if (birthDay > dayCount) {
      this.props.changeBirthDay(dayCount);
    }
  }

  submit = (values) => {
    const { accessToken } = queryString.parse(this.props.location.search);

    this.props.completeSubscriptionRequest({ values, accessToken });
  };

  render() {
    const {
      handleSubmit,
      "complete-subscription": { requesting, successful },
      birthMonth,
      birthYear,
      snackbarMessage,
    } = this.props;

    const now = new Date();
    const minYear = now.getFullYear() - 100;
    const maxYear = now.getFullYear() - 18;
    //  prettier-ignore
    const years = Array((maxYear - minYear) + 1)
      .fill(minYear)
      .map((x, y) => x + y);

    const dayCount = getDayCount(birthMonth, birthYear);
    const days = Array(dayCount)
      .fill(1)
      .map((x, y) => x + y);

    return (
      <CenteredForm
        title="Compléter vos informations"
        handleOnSubmit={handleSubmit(this.submit)}
        snackbarMessage={snackbarMessage}
      >
        <div className="mb2">
          <Field
            name="password"
            placeholder="Mot de passe *"
            label="Mot de passe *"
            component={TextField}
            validate={[required]}
            fullWidth
          />
        </div>
        <div className="mb2">
          <Field
            name="passwordCheck"
            type="password"
            placeholder="Confirmation mot de passe *"
            label="Confirmation mot de passe *"
            component={TextField}
            validate={[required]}
            fullWidth
          />
        </div>
        <div className="mb2">
          <Field
            name="lastName"
            placeholder="Nom *"
            label="Nom *"
            component={TextField}
            validate={[required]}
            fullWidth
          />
        </div>
        <div className="mb2">
          <Field
            name="firstName"
            placeholder="Prénom *"
            label="Prénom *"
            component={TextField}
            validate={[required]}
            fullWidth
          />
        </div>
        <div className="mb2">
          <Typography type="subheading" className="mb1">
            Date de naissance
          </Typography>
          <div className={styles.fields}>
            <FormControl className={styles.field}>
              <InputLabel htmlFor="birthDay">Jour *</InputLabel>
              <Field
                id="birthDay"
                name="birthDay"
                component={Select}
                validate={[required]}
              >
                {days.map((day) => (
                  <MenuItem value={day} key={day}>
                    {day}
                  </MenuItem>
                ))}
              </Field>
            </FormControl>
            <FormControl className={styles.field}>
              <InputLabel htmlFor="birthMonth">Mois *</InputLabel>
              <Field
                id="birthMonth"
                name="birthMonth"
                component={Select}
                validate={[required]}
                onChange={this.onMonthChange}
              >
                {months.map(({ name }, index) => (
                  <MenuItem value={index} key={name}>
                    {name}
                  </MenuItem>
                ))}
              </Field>
            </FormControl>
            <FormControl className={styles.field}>
              <InputLabel htmlFor="birthYear">Année *</InputLabel>
              <Field
                id="birthYear"
                name="birthYear"
                component={Select}
                validate={[required]}
              >
                {years.map((year) => (
                  <MenuItem value={year} key={year}>
                    {year}
                  </MenuItem>
                ))}
              </Field>
            </FormControl>
          </div>
        </div>
        <div className="mb2">
          <Field
            name="address"
            placeholder="Adresse *"
            label="Adresse *"
            component={TextField}
            validate={[required]}
            fullWidth
          />
        </div>
        <div className="mb2">
          <Field
            name="siret"
            placeholder="SIRET"
            label="SIRET"
            component={TextField}
            fullWidth
          />
        </div>
        <div className="mb3">
          <Field
            name="socialReason"
            placeholder="Raison sociale"
            label="Raison sociale"
            component={TextField}
            fullWidth
          />
        </div>
        {!successful && (
          <Button
            type={requesting ? "" : "submit"}
            variant="raised"
            color="secondary"
            fullWidth
          >
            {!requesting && !successful && "Envoyer"}
            {requesting && <CircularProgress className={styles.requesting} />}
          </Button>
        )}
        {successful && (
          <Link to="/login" replace>
            <Button variant="raised" color="secondary" fullWidth>
              Continuer
            </Button>
          </Link>
        )}
      </CenteredForm>
    );
  }
}

const selector = formValueSelector("complete-subscription");
const mapStateToProps = (state) => ({
  "complete-subscription": state["complete-subscription"],
  ...selector(state, "birthDay", "birthMonth", "birthYear"),
  snackbarMessage: getLatestMessage(state) || {},
});

//  eslint-disable-next-line max-len
const ConnectedCompleteSubscription = connect(mapStateToProps, {
  completeSubscriptionRequest,
  changeBirthDay: (birthDay) =>
    change("complete-subscription", "birthDay", birthDay),
})(CompleteSubscription);

export default reduxForm({
  form: "complete-subscription",
})(ConnectedCompleteSubscription);



// WEBPACK FOOTER //
// ./src/pages/complete-subscription/CompleteSubscription.jsx